import React from 'react'
import useLoginfo from './useLoginfo'

const Home = () => {
    const { userInfo } = useLoginfo()

    return (
        <div className="myfoot">
            <h1 style={{ margin: "100px", color: "#0087d0" }}>{!userInfo ? "Please login to access CTB Admin Tool" : `Welcome, ${userInfo.name}`}</h1>

            <h3>
                This password protected site is for True Value Company Members only |
                @{new Date().getFullYear()} True Value Company
            </h3></div>
    )
}

export default Home